import React from 'react';
import './ui.css';

export function Chip({ icon: Icon, children, variant = 'default', className = '' }) {
  return (
    <span className={`chip chip-${variant} ${className}`}>
      {Icon && <Icon className="chip-icon" />}
      {children}
    </span>
  );
} 